export default __webpack_public_path__ + "assets/gold.76abfdb6af60dd34dbcf596323ac818c.svg";